import { Component } from '@angular/core';
import { Club } from 'src/app/model/Club';
import { AuthService } from 'src/app/services/auth.service';
import { ClubService } from 'src/app/services/club.service';

@Component({
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss']
})
export class BannerComponent {

  userName!:string;
  club!:Club;
  showBanner:boolean = false;
  constructor(private authService:AuthService, private clubService:ClubService) {
    this.getUserDetails();
    this.getClubDetails()
  }

  login(){
    this.authService.microsoftLogin();
  }

  logout(){
    this.authService.microsoftLogout();
  }
  
  getUserDetails(){
    this.userName = this.authService.getUserDetails().name;
  }

  async getClubDetails(){
    this.club = await this.clubService.getClubInfo();
    this.showBanner = true;
  }

}
